import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createSalesBillsDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('SalesBills').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.SalesBillsPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('SalesBills').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getSalesBillsDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SalesBills').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getSalesBillsDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SalesBills').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getSalesBillsDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('SalesBills').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllSalesBillsDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SalesBills').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updateSalesBillsDocument = async (product) => {
    const docRef = db.doc(`/SalesBills/${product._id}`);
    return docRef.update(product);
}